// Network Error Handler - SHA SHA
// טיפול בשגיאות רשת ומצב offline

class NetworkErrorHandler {
  constructor() {
    this.isOnline = navigator.onLine;
    this.retryCount = 0;
    this.maxRetries = 3;
    this.retryDelay = 2000;
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    // האזנה לשינויים במצב הרשת
    window.addEventListener('online', () => {
      this.isOnline = true;
      this.showOnlineMessage();
      this.retryFailedRequests();
    });

    window.addEventListener('offline', () => {
      this.isOnline = false;
      this.showOfflineMessage();
    });

    // האזנה לשגיאות רשת
    window.addEventListener('error', (event) => {
      if (event.target.tagName === 'SCRIPT' || event.target.tagName === 'LINK') {
        this.handleResourceError(event);
      }
    });
  }

  handleResourceError(event) {
    console.warn('שגיאה בטעינת משאב:', event.target.src || event.target.href);
    
    // ניסיון לטעון מחדש
    if (this.retryCount < this.maxRetries) {
      setTimeout(() => {
        this.retryCount++;
        this.retryLoadResource(event.target);
      }, this.retryDelay * this.retryCount);
    }
  }

  retryLoadResource(element) {
    const originalSrc = element.src || element.href;
    if (originalSrc) {
      element.src = originalSrc + '?retry=' + this.retryCount;
      element.href = originalSrc + '?retry=' + this.retryCount;
    }
  }

  showOfflineMessage() {
    // הצגת הודעה למשתמש
    const message = document.createElement('div');
    message.id = 'offline-message';
    message.innerHTML = `
      <div style="
        position: fixed;
        top: 20px;
        right: 20px;
        background: #ff9800;
        color: white;
        padding: 15px;
        border-radius: 5px;
        z-index: 10000;
        font-family: Arial, sans-serif;
        box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      ">
        <strong>אין חיבור לאינטרנט</strong><br>
        חלק מהפונקציות לא יהיו זמינות
      </div>
    `;
    document.body.appendChild(message);
  }

  showOnlineMessage() {
    const message = document.getElementById('offline-message');
    if (message) {
      message.innerHTML = `
        <div style="
          position: fixed;
          top: 20px;
          right: 20px;
          background: #4caf50;
          color: white;
          padding: 15px;
          border-radius: 5px;
          z-index: 10000;
          font-family: Arial, sans-serif;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        ">
          <strong>החיבור לאינטרנט חזר</strong><br>
          כל הפונקציות זמינות כעת
        </div>
      `;
      setTimeout(() => {
        message.remove();
      }, 3000);
    }
  }

  retryFailedRequests() {
    // ניסיון לשלוח בקשות שנכשלו
    if (window.failedRequests && window.failedRequests.length > 0) {
      console.log('מנסה לשלוח בקשות שנכשלו...');
      window.failedRequests.forEach(request => {
        this.retryRequest(request);
      });
      window.failedRequests = [];
    }
  }

  retryRequest(request) {
    fetch(request.url, request.options)
      .then(response => {
        if (response.ok) {
          console.log('בקשה נשלחה בהצלחה:', request.url);
        }
      })
      .catch(error => {
        console.warn('בקשה עדיין נכשלת:', request.url, error);
      });
  }

  // פונקציה לבדיקת חיבור
  async checkConnection() {
    try {
      const response = await fetch('/health', {
        method: 'GET',
        timeout: 5000
      });
      return response.ok;
    } catch (error) {
      console.warn('בדיקת חיבור נכשלה:', error);
      return false;
    }
  }

  // פונקציה לשליחת בקשה עם retry
  async fetchWithRetry(url, options = {}) {
    for (let i = 0; i < this.maxRetries; i++) {
      try {
        const response = await fetch(url, {
          ...options,
          timeout: 10000
        });
        
        if (response.ok) {
          return response;
        }
      } catch (error) {
        console.warn(`ניסיון ${i + 1} נכשל:`, error);
        
        if (i === this.maxRetries - 1) {
          // שמירת הבקשה לניסיון מאוחר יותר
          if (!window.failedRequests) {
            window.failedRequests = [];
          }
          window.failedRequests.push({ url, options });
          throw error;
        }
        
        // המתנה לפני הניסיון הבא
        await new Promise(resolve => setTimeout(resolve, this.retryDelay * (i + 1)));
      }
    }
  }
}

// יצירת instance גלובלי
const networkErrorHandler = new NetworkErrorHandler();

export default networkErrorHandler; 